import HeaderBar from "../../../components/header/headerBar";
// import { Input } from "../../../components/textfield";
import "../../../assets/styles/components/select.scss";
import { useRef, useState, useEffect } from "react";
import { getLocalUrl } from "../../../functions";
import { useParams } from "react-router-dom";
import "../../../assets/styles/admin/branchCreate.scss";
import { useHistory } from "react-router-dom";

import { Col, Form, Input, Row, Space, Button, Upload, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useForm } from "antd/lib/form/Form";
import axios from "axios";
import { Icon } from "@iconify/react";

const BranchesCategory = () => {
  const { Text } = Typography;

  const history = useHistory();
  let [formCreateBranch] = Form.useForm();
  const fileInput: any = useRef();
  const [uploadFile, setUploadFile] = useState<any>([]);

  const [isDisable, setIsDisable] = useState<any>([]);

  const onUploadIconClick = () => {
    console.log("click...");
    fileInput.current.click();
  };

  const onFileInputChange = (e: any) => {
    console.log("e change pic =>", e.file);
    const { originFileObj } = e.file;

    const url = getLocalUrl(originFileObj);
    if (e.file.status !== "removed") {
      setUploadFile([
        {
          uid: "1",
          name: e?.file?.name,
          url: url,
        },
      ]);
    } else {
      formCreateBranch.setFieldsValue({ file: "" });
      setUploadFile([]);
    }
  };

  useEffect(() => {
    setIsDisable({
      ...isDisable,
      isUpload: true,
    });
  }, []);

  const onKeydownCheck = (eveb: KeyboardEvent) => {
    console.log("e event", eveb.which);
    if (eveb.which !== 8) {
      eveb.preventDefault();
      // message.error("Please Input Max 10 ");
    }
  };
  const Onsubmit = (value: any) => {
    createDatas(value);
  };
  const createDatas = async (value: any) => {
    // const datas = await axios.post(`/branches`, value).then((res) => {});
    console.log("UploadFile", value);
    const Datas = value;
    try {
      const xDatas = await axios.post(`/branches`, Datas);
      console.log("_id", xDatas?.data?._id);

      const _id = xDatas?.data?._id;
      const fmData = new FormData();
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };
      // console.log("data", Datas?.file?.fileList?.originFileObj);

      fmData.append("file", Datas?.uploadId?.fileList[0]?.originFileObj);

      await axios.patch(
        `/branches/upload-file?uploadId=${_id}`,
        fmData,
        config
      );
    } catch (error) {}
    history.push(`/setting/branches`);
  };
  return (
    <div>
      <HeaderBar title="BRANCHES / CREATE" btnBack={true} />
      <Form form={formCreateBranch} onFinish={Onsubmit} layout="vertical">
        <div style={{ padding: "10px 50px" }}>
          <div className="create-page" style={{ padding: "30px 20px" }}>
            <Row justify="space-around" className="form-branchCreate ">
              <Col span={7}>
                <Form.Item
                  name="code"
                  label="Branch Code"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Branch Code!",
                    },
                  ]}
                >
                  <Input type="text" />
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item
                  name="name"
                  label="Branch Name (THAI)"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Branch Name (THAI)!",
                    },
                  ]}
                >
                  <Input type="text" />
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item
                  name="nameEN"
                  label="Branch Name (ENG)"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Branch Name (ENG)!",
                    },
                  ]}
                >
                  <Input type="text" />
                </Form.Item>
              </Col>
            </Row>

            <Row justify="space-around" className="form-branchCreate ">
              <Col span={7}>
                <Form.Item
                  name="taxNumber"
                  label="Tax ID Number"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Tax ID Number!",
                    },
                  ]}
                >
                  <Input type="number" />
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item
                  name="phone"
                  label="Tel."
                  rules={[
                    {
                      required: true,
                      message: "Please input your Tel.!",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    onKeyDown={(e: any) => {
                      if (e.target.value.length > 9) {
                        onKeydownCheck(e);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item
                  name="fax"
                  label="Fax."
                  rules={[
                    {
                      required: true,
                      message: "Please input your Fax.!",
                    },
                  ]}
                >
                  <Input type="number" />
                </Form.Item>
              </Col>
            </Row>
            <Row className="form-branchCreate ">
              <Col span={23} style={{ marginLeft: "20px" }}>
                <Form.Item
                  name="googleMap"
                  label="Location link (Google map)"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Location link (Google map)!",
                    },
                  ]}
                >
                  <Input type="text" />
                </Form.Item>
              </Col>
            </Row>
            <Row className="form-branchCreate ">
              <Col span={23} style={{ marginLeft: "20px" }}>
                <Form.Item
                  name="address"
                  label="Branch Address (THAI)"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Branch Address (THAI)!",
                    },
                  ]}
                >
                  <Input type="text" />
                </Form.Item>
              </Col>
            </Row>
            <Row className="form-branchCreate">
              <Col span={23} style={{ marginLeft: "20px" }}>
                <Form.Item
                  name="addressEN"
                  label="Branch Address (ENG)"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Branch Address (ENG)!",
                    },
                  ]}
                >
                  <Input type="text" />
                </Form.Item>
              </Col>
            </Row>

            {/* <div className="row mt-20">
              <div style={{ color: "#aaa", fontSize: "14px" }}>ภาพสาขา</div>
              <div className="pick-img col-3" onClick={onUploadIconClick}>
                <label
                  htmlFor="img"
                  className="box-image"
                  style={{
                    backgroundImage: `url('${uploadFile}')`,
                  }}
                >
                  {!uploadFile && (
                    <div id="rounded">
                      <Icon path={mdiImageOutline} size="30" color="#fff" />
                    </div>
                  )}
                  {!uploadFile && "อัพโหลดภาพ"}
                </label>
                <input
                  ref={fileInput}
                  type="file"
                  name="beforeImage"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    onFileInputChange(e);
                  }}
                />
              </div>
            </div> */}
            <Row
              className="form-branchCreate "
              style={{ marginTop: "10px", paddingLeft: "20px" }}
            >
              <Form.Item
                name="uploadId"
                label="Branch Picture"
                rules={[
                  {
                    required: true,
                    message: "Please input your PictreBranch !",
                  },
                ]}
                className="branch-pic"
              >
                <Upload
                  listType="picture-card"
                  onChange={(e) => {
                    console.log("e v1 =>", e);
                    if (e.fileList.length !== 0) {
                      setIsDisable({ ...isDisable, isUpload: false });
                    }
                    onFileInputChange(e);
                  }}
                  customRequest={({ onSuccess }: any) => {
                    onSuccess();
                  }}
                  onRemove={(e) => {
                    console.log("e v2 =>", e);
                    setIsDisable({ ...isDisable, isUpload: true });
                  }}
                  fileList={uploadFile}
                  accept="image/*"
                >
                  {isDisable?.isUpload && (
                    <>
                      <Row justify="center">
                        <Col>
                          <Icon
                            icon="ic:round-add-photo-alternate"
                            color="#C4C4C4"
                            height="50"
                            width="50"
                          />
                        </Col>
                        <Col>
                          <Text
                            style={{ color: "#4d7e7f", fontSize: "12px" }}
                            strong
                          >
                            UPLOAD IMAGE
                          </Text>
                        </Col>
                      </Row>
                    </>
                  )}
                </Upload>
              </Form.Item>

              {/* <Col
                className="pick-img col-3"
                onClick={onUploadIconClick}
                style={{ paddingLeft: "20px" }}
              >
                <span style={{ fontSize: "14px", color: "#5baea9" }}>
                  Branch Picture
                </span>
                <label
                  htmlFor="img"
                  className="box-image"
                  style={{
                    backgroundImage: `url('${uploadFile}')`,
                  }}
                >
                  {!uploadFile && (
                    <div id="rounded">
                      <Icon path={mdiImageOutline} size="30" color="#fff" />
                    </div>
                  )}
                  {!uploadFile && "อัพโหลดภาพ"}
                </label>
                <input
                  ref={fileInput}
                  type="file"
                  name="beforeImage"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    onFileInputChange(e);
                  }}
                />
              </Col> */}
            </Row>
          </div>
        </div>
        <Row
          className="button-branchcreate"
          justify="center"
          style={{ marginTop: "10px" }}
        >
          <Col>
            <Space>
              <Button
                onClick={() => history.push(`/setting/branches`)}
                className="cancleButton-branchcreate"
              >
                ยกเลิก/Cancel
              </Button>
              <Button
                className="confirmButton-branchcreate"
                htmlType="submit"
                // onClick={() => }
              >
                บันทึกข้อมูล/Submit
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
export default BranchesCategory;
